export default __webpack_public_path__ + "static/media/5.3af811f5.jpg";